<div class="header">
  <div>
    <h2>
      {{ isFormVisible ? "Add new Roles" : "Roles Setup" }}
    </h2>
    <p>
      {{
      isFormVisible
      ? "Create a new role by defining its name and permissions. This will help manage access for different users in the
      system."
      : "Easily configure and manage automated text messages to streamline communication and ensure timely
      notifications."
      }}
    </p>
  </div>

  @if (!isFormVisible) {
  <button class="add-btn" (click)="toggleView()">
    <img src="assets/images/PlusIcon.svg" alt="" />
    Add New Role
  </button>
  }
</div>

<div class="rp-body">
  @if (!isFormVisible) {
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Type</th>
          <th>Created By</th>
          <th>Created Date</th>
          <th>Status</th>
          <th class="text-right pr-4">Action</th>
        </tr>
      <tbody *ngIf="loading || showSkeleton">
        <tr *ngFor="let row of skeletonRows">
          <td *ngFor="let col of skeletonCols">
            <div class="skeleton-cell"></div>
          </td>
        </tr>
      </tbody>

      <tbody *ngIf="!loading && !showSkeleton">
        @for (item of roles; track item.id) {
        <tr>
          <td>{{ item.role_name }}</td>
          <td>{{ item.role_type }}</td>
          <td>{{ item.created_by }}</td>
          <td>{{ item.created_date }}</td>
          <td>
            <span class="badge" [class.badge-paid]="item.is_active === 1" [class.badge-unpaid]="item.is_active !== 1">
              {{ item.is_active === 1 ? "active" : "inactive" }}
            </span>
          </td>
          <td class="text-right">
            <div class="icon-btns">
              <button class="btn-icon" (click)="openEditForm(item)">
                <img src="assets/images/editIcon.svg" alt="Edit" />
              </button>
              <button class="btn-icon" (click)="openDeleteModal(item.id)">
                <img src="assets/images/trashIcon.svg" alt="Delete" />
              </button>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  } @else {
  <div class="form-container">
    @if (loading || showSkeleton) {
    <h3>
      <div class="skeleton-row" style="width: 150px; height: 24px; margin-bottom: 15px; border-radius: 4px;"></div>
    </h3>
    <div class="table-wrapper">
      <div class="radio-group" style="padding: 15px;">
        <div class="skeleton-row" style="width: 100%; height: 24px; border-radius: 4px;"></div>
      </div>
    </div>
    <div class="role-info-card">
      <div class="skeleton-row" style="width: 150px; height: 28px; margin-bottom: 20px; border-radius: 4px;"></div>
      <div class="skeleton-row" style="width: 80px; height: 18px; margin-bottom: 10px; border-radius: 4px;"></div>
      <div class="skeleton-row" style="width: 100%; height: 45px; margin-bottom: 20px; border-radius: 8px;"></div>
      <div class="skeleton-row" style="width: 120px; height: 20px; border-radius: 4px;"></div>
    </div>
    <div class="permissions-section">
      <div class="skeleton-row" style="width: 200px; height: 24px; margin-bottom: 20px; border-radius: 4px;"></div>
      <div class="skeleton-row" style="width: 180px; height: 20px; margin-bottom: 20px; border-radius: 4px;"></div>

      <div class="permission-card">
        <div class="skeleton-row" style="width: 150px; height: 20px; border-radius: 4px;"></div>
      </div>
      <div class="permission-card">
        <div class="skeleton-row" style="width: 150px; height: 20px; border-radius: 4px;"></div>
      </div>
      <div class="permission-card">
        <div class="skeleton-row" style="width: 150px; height: 20px; border-radius: 4px;"></div>
      </div>
      <div class="permission-card">
        <div class="skeleton-row" style="width: 150px; height: 20px; border-radius: 4px;"></div>
      </div>
    </div>
    } @else {
    <h3>Role Type:</h3>
    <div class="table-wrapper">
      <div class="radio-group">
        <label><input type="radio" name="role" value="Employee" [(ngModel)]="selectedRoleType" />
          Employee</label>
        <label><input type="radio" name="role" value="Team Lead + Admin" [(ngModel)]="selectedRoleType" />
          Team Lead</label>
        <label><input type="radio" name="role" value="Admin" [(ngModel)]="selectedRoleType" />
          Admin</label>
        <!-- <label><input type="radio" name="role" value="Team Lead + Admin" [(ngModel)]="selectedRoleType" />
          Team Lead + Admin</label> -->
      </div>
    </div>
    <div class="role-info-card">
      <h2>Role Info:</h2>
      <div class="role-info-main">
        <div class="input-group">
          <label class="title">Title*</label>
          <input type="text" placeholder="Write here" name="roleTitle" [(ngModel)]="roleTitle" />
          <div class="checkbox-row">
            <input type="checkbox" id="active" [(ngModel)]="isRoleActive" />
            <label for="active" class="m-0">Role is active...</label>
          </div>
        </div>
        @if (
        selectedRoleType === "Team Lead + Admin"){
        <!-- <div class="input-group">
          <label class="title">Department*</label>

          <select [(ngModel)]="selectedDepartmentId">
            <option [ngValue]="null" disabled class="select-option">Select Department</option>
            <option *ngFor="let dep of departments" [ngValue]="dep.id">
              {{ dep.department_name }}
            </option>
          </select>
        </div> -->


      <div class="multi-select">
        <label class="title">Department*</label>

        <!-- Dropdown -->
        <select (change)="onSelect($event)">
          <option value="" disabled selected>Select Department</option>

          <option *ngFor="let dep of departments" [value]="dep.id">
            {{ dep.department_name }}
          </option>
        </select>
      </div>


      <!-- Selected Tags -->
        <div class="tags">
          <span class="tag" *ngFor="let dep of selectedDepartments">
            {{ dep.department_name }}
            <i (click)="remove(dep.id)">×</i>
          </span>
        </div>



        }


      </div>
    </div>

    @if (
    selectedRoleType === "Admin" ||
    selectedRoleType === "Team Lead + Admin"
    ) {
    <div class="permissions-section">
      <h3>Role Permissions:</h3>
      <div class="checkbox-row mb-3">
        <input type="checkbox" checked id="checkAll" [(ngModel)]="isCheckAllSelected"
          (change)="toggleAllPermissions()" />
        <label for="checkAll" class="m-0">Check All Permission</label>
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="teamEval" [(ngModel)]="isTeamEvalSelected" (change)="onTeamEvalChange()" />
          <label for="teamEval" class="m-0">Team Evaluation</label>
        </div>
        @if (isTeamEvalSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label><input type="radio" name="evalType" [value]="'all'" [(ngModel)]="teamEvalType" />
              For All</label>
            <label><input type="radio" name="evalType" [value]="'team'" [(ngModel)]="teamEvalType" />
              For Team</label>
          </div>
          <div class="chip-container">
            <!-- <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamEvalPermissions.checkAll" checked />
                <span class="chip-text">Check all</span>
              </span>
            </label> -->

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamEvalPermissions.viewList" checked />
                <span class="chip-text">View List</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamEvalPermissions.update" />
                <span class="chip-text">Update</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamEvalPermissions.addNew" />
                <span class="chip-text">Add New</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>
      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="teamManag" [(ngModel)]="isTeamManagSelected" (change)="onTeamManagementChange()" />
          <label for="teamManag" class="m-0">Team Managment</label>
        </div>
        @if (isTeamManagSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label>
              <input type="radio" name="managType" [value]="'all'" [(ngModel)]="teamManagementType" />
              For All
            </label>
            <label>
              <input type="radio" name="managType" [value]="'team'" [(ngModel)]="teamManagementType" />
              For Team
            </label>
          </div>

          <div class="chip-container">


            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.view" checked />
                <span class="chip-text">View Team</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.update" checked />
                <span class="chip-text">Allow WFH</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.addUser" />
                <span class="chip-text">Add New User</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.updateUser" />
                <span class="chip-text">Update User</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.deleteUser" />
                <span class="chip-text">Delete User</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.monthlySalary" checked />
                <span class="chip-text">Monthly Salary</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.loanView" />
                <span class="chip-text">Loan View</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.loanAccept" />
                <span class="chip-text">Loan Accept</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.loanReject" checked />
                <span class="chip-text">Loan Reject</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.reset2fa" checked />
                <span class="chip-text">Reset 2FA</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamManagementPermissions.action2fa" checked />
                <span class="chip-text">Enable/Disable 2FA</span>
              </span>
            </label>

          </div>
        </div>
        }
      </div>
      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="teamResign" [(ngModel)]="isTeamResignSelected" (change)="onTeamResignChange()" />
          <label for="teamResign" class="m-0">Team Resign</label>
        </div>
        @if (isTeamResignSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label>
              <input type="radio" name="resignType" [value]="'all'" [(ngModel)]="teamResignType" />
              For All
            </label>
            <label>
              <input type="radio" name="resignType" [value]="'team'" [(ngModel)]="teamResignType" />
              For Team
            </label>
          </div>
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamResignPermissions.view" checked />
                <span class="chip-text">View Resign</span>
              </span>
            </label>
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamResignPermissions.accept" checked />
                <span class="chip-text">Accept Resign</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="teamResignPermissions.reject" checked />
                <span class="chip-text">Reject Resign</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>
      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="holidays" (change)="onHolidayChange()" [(ngModel)]="isHolidaysSelected" />
          <label for="holidays" class="m-0">Holidays</label>
        </div>
        @if (isHolidaysSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label><input type="radio" name="holidayType" [value]="'all'" [(ngModel)]="holidayType" />
              For All</label>
            <label><input type="radio" name="holidayType" [value]="'team'" [(ngModel)]="holidayType" />
              For Team</label>
          </div>
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="holidaysPermissions.view" />
                <span class="chip-text">View List</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="holidaysPermissions.add" checked />
                <span class="chip-text">Add New</span>
              </span>
            </label>
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="holidaysPermissions.update" checked />
                <span class="chip-text">Update</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="holidaysPermissions.delete" checked />
                <span class="chip-text">Delete</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>
      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="media" [(ngModel)]="isMediaSelected" (change)="onMediaChange()" />
          <label for="media" class="m-0">Upload Media</label>
        </div>
        @if (isMediaSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label>
              <input type="radio" name="mediaType" [value]="'all'" [(ngModel)]="mediaType" />
              For All
            </label>
            <label>
              <input type="radio" name="mediaType" [value]="'team'" [(ngModel)]="mediaType" />
              For Team
            </label>
          </div>

          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="mediaPermissions.view" />
                <span class="chip-text">View List</span>
              </span>
            </label>
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="mediaPermissions.accept" />
                <span class="chip-text">Accept</span>
              </span>
            </label>
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="mediaPermissions.reject" />
                <span class="chip-text">Reject</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="leave" [(ngModel)]="isLeaveSelected" (change)="onLeaveChange()" />
          <label for="leave" class="m-0">Leave Management</label>
        </div>

        @if (isLeaveSelected) {
        <div class="perm-options">
          <div class="radioss">
            <label>
              <input type="radio" name="leaveType" [value]="'all'" [(ngModel)]="leaveType" />
              For All
            </label>

            <label>
              <input type="radio" name="leaveType" [value]="'team'" [(ngModel)]="leaveType" />
              For Team
            </label>
          </div>

          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.view_leave" />
                <span class="chip-text">View All</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.accept" />
                <span class="chip-text">Accept Leaves</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.reject" />
                <span class="chip-text">Reject Leaves</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.update" />
                <span class="chip-text">Update Leave</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.undo_leave" />
                <span class="chip-text">Undo Leave</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.view_leave_report" />
                <span class="chip-text">View Leave Report</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="leavePermissions.reset_leave" />
                <span class="chip-text">Reset Leave</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="attendanceMgmt" [(ngModel)]="isAttendanceSelected"
            (change)="onAttendanceChange()" />
          <label for="attendanceMgmt" class="m-0">Attendance Management</label>
        </div>

        @if (isAttendanceSelected) {
        <div class="perm-options">
          <!-- RADIO OPTIONS -->
          <div class="radioss">
            <label>
              <input type="radio" name="attendanceType" [value]="'all'" [(ngModel)]="attendanceType" />
              For All
            </label>

            <label>
              <input type="radio" name="attendanceType" [value]="'team'" [(ngModel)]="attendanceType" />
              For Team
            </label>
          </div>

          <!-- PERMISSION CHIPS -->
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.view_attedance" />
                <span class="chip-text">View Attendance</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.sheet" />
                <span class="chip-text">Add Attendance Sheet</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.update" />
                <span class="chip-text">Edit Attendance</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.report" />
                <span class="chip-text">View Atendance Request</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.edit" />
                <span class="chip-text">Accept Attendance Req</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="attendancePermissions.delete" />
                <span class="chip-text">Reject Attendance Req</span>
              </span>
            </label>

          </div>
        </div>
        }
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="eventMgmt" [(ngModel)]="isEventSelected" (change)="onEventChange()" />
          <label for="eventMgmt" class="m-0">Event Management</label>
        </div>

        @if (isEventSelected) {
        <div class="perm-options">
          <!-- RADIO OPTIONS -->
          <div class="radioss">
            <label>
              <input type="radio" name="eventType" [value]="'all'" [(ngModel)]="eventType" />
              For All
            </label>

            <label>
              <input type="radio" name="eventType" [value]="'team'" [(ngModel)]="eventType" />
              For Team
            </label>
          </div>

          <!-- PERMISSION CHIPS -->
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="eventPermissions.view" />
                <span class="chip-text">View Event</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="eventPermissions.add" />
                <span class="chip-text">Add</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="eventPermissions.edit" />
                <span class="chip-text">Edit</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="eventPermissions.delete" />
                <span class="chip-text">Delete</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="accountMgmt" [(ngModel)]="isAccountSelected" (change)="onAccountChange()" />
          <label for="accountMgmt" class="m-0">Account Management</label>
        </div>

        @if (isAccountSelected) {
        <div class="perm-options">
          <!-- RADIO OPTIONS -->
          <div class="radioss">
            <label>
              <input type="radio" name="accountType" [value]="'all'" [(ngModel)]="accountType" />
              For All
            </label>

            <label>
              <input type="radio" name="accountType" [value]="'team'" [(ngModel)]="accountType" />
              For Team
            </label>
          </div>

          <!-- PERMISSION CHIPS -->
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="accountPermissions.view" />
                <span class="chip-text">View</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="accountPermissions.add" />
                <span class="chip-text">Add</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="accountPermissions.edit" />
                <span class="chip-text">Edit</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="accountPermissions.delete" />
                <span class="chip-text">Delete</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="accountPermissions.export" />
                <span class="chip-text">Export Sheet</span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>
      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="settingMgmt" [(ngModel)]="isSettingSelected" (change)="onSettingChange()" />
          <label for="settingMgmt" class="m-0">Setting's</label>
        </div>

        @if (isSettingSelected) {
        <div class="perm-options">
          <!-- RADIO OPTIONS -->
          <div class="radioss">
            <label>
              <input type="radio" name="settingType" [value]="'all'" [(ngModel)]="settingType" />
              For All
            </label>

            <label>
              <input type="radio" name="settingType" [value]="'team'" [(ngModel)]="settingType" />
              For Team
            </label>
          </div>

          <!-- PERMISSION CHIPS -->
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="settingPermissions.view" />
                <span class="chip-text">View</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="settingPermissions.add" />
                <span class="chip-text">Add </span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="settingPermissions.edit" />
                <span class="chip-text">Edit </span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="settingPermissions.delete" />
                <span class="chip-text">Delete </span>
              </span>
            </label>
          </div>
        </div>
        }
      </div>

      <div class="permission-card">
        <div class="checkbox-row">
          <input type="checkbox" id="settingMgmt" [(ngModel)]="isPayrollSelected" (change)="onSettingChange()" />
          <label for="settingMgmt" class="m-0">Payroll Management</label>
        </div>

        @if (isPayrollSelected) {
        <div class="perm-options">
          <!-- RADIO OPTIONS -->
          <div class="radioss">
            <label>
              <input type="radio" name="payrollType" [value]="'all'" [(ngModel)]="payrollType" />
              For All
            </label>

            <label>
              <input type="radio" name="payrollType" [value]="'team'" [(ngModel)]="payrollType" />
              For Team
            </label>
          </div>

          <!-- PERMISSION CHIPS -->
          <div class="chip-container">
            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.view_summary" />
                <span class="chip-text">View Summary</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.view_monthly" />
                <span class="chip-text">View Monthly Detail</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.add" />
                <span class="chip-text">Generate Payroll</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.approve" />
                <span class="chip-text">Approve Payroll</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.release" />
                <span class="chip-text">Release Payroll</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.detail" />
                <span class="chip-text">View User Detail</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.preview" />
                <span class="chip-text">Preview Salary Detail</span>
              </span>
            </label>

            <label class="custom-chip">
              <span class="chip-content">
                <input type="checkbox" [(ngModel)]="payrollPermissions.admin" />
                <span class="chip-text">Add Admin list</span>
              </span>
            </label>


          </div>
        </div>
        }
      </div>
    </div>
    }
    }
  </div>

  <div class="add-roles-btn">
    <button class="cancel-btn" (click)="toggleView()">Cancel</button>
    <button class="save-btn" (click)="onSave()" [disabled]="isSaving">
      Save
    </button>
  </div>
  }
</div>

<!-- Edit Confirmation Modal -->
<app-add-popup *ngIf="showDeleteModal" title="Delete Role"
  subtitle="Are you sure you want to delete this role? This action cannot be undone."
  iconPath="assets/images/deleteicon.svg" (close)="closeDeleteModal()">
  <div class="modal-footer justify-center">
    <button type="button" class="btn-cancel" (click)="closeDeleteModal()">
      Cancel
    </button>

    <button type="button" class="btn-save" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</app-add-popup>